import { cn } from "@/utils/cn"
import { ComponentProps } from "react"

interface HamburgerIconProps extends ComponentProps<"svg"> {
  open: boolean
}

export function HamburgerIcon({ open, ...props }: HamburgerIconProps) {
  return (
    <svg
      width="40"
      height="33"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <line
        x1="3"
        y1="6"
        x2="21"
        y2="6"
        className={cn(
          "transition-transform duration-300 ease-out",
          open && "rotate-45"
        )}
        style={{ transformOrigin: "4px 8px" }}
      />
      <line
        x1="3"
        y1="12"
        x2="21"
        y2="12"
        className={cn(
          "transition-opacity duration-200 ease-out",
          open && "opacity-0"
        )}
      />
      <line
        x1="3"
        y1="18"
        x2="21"
        y2="18"
        className={cn(
          "transition-transform duration-300 ease-out",
          open && "-rotate-45"
        )}
        style={{ transformOrigin: "4px 16px" }}
      />
    </svg>
  )
}
